import { useId } from "react";
import { GLYPHS, GLYPH_TOP, TRI, TX, TY } from "./logoPaths";

const [AX, AY] = TRI.apex;
const PTS = `${AX},${AY} ${AX + TRI.half},${TRI.base} ${AX - TRI.half},${TRI.base}`;
const HALF_STROKE = TRI.stroke / 2;

export const VIEWBOX = {
    x: AX - TRI.half - HALF_STROKE,
    y: AY - HALF_STROKE,
    w: (TRI.half + HALF_STROKE) * 2,
    h: TRI.base + HALF_STROKE - (AY - HALF_STROKE),
};
const VB = `${VIEWBOX.x} ${VIEWBOX.y} ${VIEWBOX.w} ${VIEWBOX.h}`;

export const Monogram = ({
    className = "",
    letters = true,
    ink = "var(--crema)",
    paper = "var(--nero)",
}) => {
    const id = `apf-${useId().replace(/[^a-zA-Z0-9]/g, "")}`;
    return (
        <svg className={className} viewBox={VB} aria-hidden="true" focusable="false">
            {letters && (
                <defs>
                    <clipPath id={id}>
                        <polygon points={PTS} />
                    </clipPath>
                </defs>
            )}
            <polygon
                points={PTS}
                fill={ink}
                stroke={ink}
                strokeWidth={TRI.stroke}
                strokeLinejoin="round"
            />
            {letters && (
                <g className="monogram-ink" clipPath={`url(#${id})`} fill={paper}>
                    <g transform={`translate(${TX} ${TY})`}>
                        {Object.keys(GLYPHS).map((k) => (
                            <path key={k} d={GLYPHS[k].d} />
                        ))}
                    </g>
                </g>
            )}
        </svg>
    );
};

export const Triangle = (props) => <Monogram {...props} letters={false} />;

export const glyphRatio = (letter) => {
    const [x0, x1] = GLYPHS[letter].box;
    return (x1 - x0) / -GLYPH_TOP;
};

// posizione % del glifo dentro il box del monogramma (stesso viewBox)
export const glyphPlacement = (letter) => {
    const [x0, x1] = GLYPHS[letter].box;
    return {
        left: `${((x0 + TX - VIEWBOX.x) / VIEWBOX.w) * 100}%`,
        width: `${((x1 - x0) / VIEWBOX.w) * 100}%`,
        top: `${((TY + GLYPH_TOP - VIEWBOX.y) / VIEWBOX.h) * 100}%`,
        height: `${(-GLYPH_TOP / VIEWBOX.h) * 100}%`,
    };
};

export const Glyph = ({ letter, className = "" }) => {
    const g = GLYPHS[letter];
    return (
        <svg
            className={className}
            viewBox={`${g.box[0]} ${GLYPH_TOP} ${g.box[1] - g.box[0]} ${-GLYPH_TOP}`}
            aria-hidden="true"
            focusable="false"
        >
            <path d={g.d} fill="currentColor" />
        </svg>
    );
};
